import React, { Component, useRef, forwardRef, useEffect } from 'react';
import { useSelector, useDispatch, connect } from 'react-redux';
import '../../../../styles/invoicesPrint.css';
import fmplogo from '../../../../assets/FMP-Icon.png';
import fmp from '../../../../assets/FMP.jpg';
import fmpaddress from '../../../../assets/FMP_address.png';
import fmpslogan from '../../../../assets/FMP_Slogan.png';


const SopRotatesPrintPage = forwardRef(function PrintPage(props, ref) {
    const { } = props;

    return (
        <div className='page' style={ {backgroundColor: 'white', position: 'relative'}}>

        <table style={ {margin: '20px', padding: '0 30px', backgroundColor: 'white', height:'100%', position: 'absolute'} }>
            <thead key={'sopRotate_headerTable'} >
                <tr>
                    <td colSpan={2} style={{position: 'relative', height:'0', width:'fit-content'}} >                            
                        <table className='printMarginHeaderCN'>
                            <thead></thead>
                            <tbody key={'sopRotate_headerTable_bodyMain'}>
                                <tr>
                                    <td className={'logo'}>
                                        <img src={fmplogo} alt='FMP Logo' width={142}/>
                                    </td>                                                               
                                </tr>
                                <tr>
                                    <td className={'logo'}>
                                        <img src={fmp} alt='FMP' width={142}/>
                                    </td>                                                               
                                </tr>                                
                            </tbody>
                        </table>
                    </td>
                </tr>               
            </thead> 
            <tbody>
                <tr>
                    <td colSpan={2} style={ {position: 'relative', height:'0', width:'fit-content', padding: '20px 0 20px 70px ', backgroundColor:'white'} }>
                        <span style={ {textDecorationLine: 'underline', padding: '0 30px 0 0'}} >Instructions for Battery Rotate Completion</span>            
                        <span style={ {textDecorationLine: 'underline'} } >v.3.28.24</span>
                    </td>                                     
                </tr>  
                <tr>
                    <td colSpan={2} style={{ position: 'relative', height:'0', width:'fit-content', backgroundColor:'white' }}>
                    
                    {/* <td style={{ top:'0', position: 'fixed', padding: '0', margin: '0', maxHeight:'fit-content', height:'fit-content', backgroundColor:'pink' }}> */}
                        <span style={{ fontWeight: 'bold', padding: '0 0 0 25px' }}>Driver:</span>
                        <br/>
                        <ol type="1" style={{ }}>
                            <li>
                            At the customer location, <span style={{ fontWeight: 'bold'}}>only deliver the new batteries if you have the corresponding old battery to collect for the same part number</span>. 
                            (always <span style={{ fontWeight: 'bold',textDecorationLine: 'underline'}}>one out, one in</span> on battery rotates)

                            <ol type="a">
                                <li>
                                    New battery to deliver, old one is on the shelf:
                                    <ol type="i">
                                        <li>
                                            Write the date code from the old battery next to this line, and bring the old battery back to the warehouse (Completed)
                                        </li>
                                    </ol>
                                </li>
                                <li>
                                    New Battery to deliver, no old ones on the shelf:
                                    <ol type="i">
                                        <li>
                                            Write “CANCEL” next to this line on the invoice copies, and bring the new battery back to the warehouse (Cancelled)
                                        </li>
                                    </ol>                                    
                                </li>
                                <li>
                                    Old battery on the customer’s shelf, but no new battery to deliver: 
                                    <ol type="i">
                                        <li>
                                            Leave the old battery on their shelf – do not collect this battery. Write “RE-REQUEST” next to this line (re-requested)
                                        </li>
                                    </ol>                                       
                                </li>
                                <li>
                                    On a battery rotate ticket, we will <span style={{ fontWeight: 'bold'}}>never deliver a new battery unless we are collecting the old battery that needs replacing</span>. 
                                    The customer's ordering system will take care of ordering the batteries they need.
                                </li>
                                <li>
                                    Driver: Please return this sheet to the warehouse manager with the proof of delivery paperwork.
                                </li>
                                <li>
                                    Any questions?: Please call Tim Denardo at: 920-224-2445
                                </li>
                            </ol>
                            </li>
                        </ol>
                    </td>                                       
                </tr>  
                <tr>
                    <td colSpan={2} style={ {position: 'relative', height:'0', width:'fit-content', backgroundColor:'white'} } >
                        <span style={{ fontWeight: 'bold', padding: '0 0 0 25px'}}>At Warehouse:</span>
                        <br/>

                        <ol type='1'>
                            <li>
                                On the FMP Processing Website: Enter the “Invoices” area, find the invoice, click the “Confirm” button.
                            </li>
                            <li>
                                In the pop-up window, enter the results of the rotate for each battery. The options for each rotate requested battery: Confirmed, Cancelled, or Re-Request. Be sure to enter the date codes for anything “Confirmed” – we will need these later to determine what to do with the collected batteries.                        
                            </li>
                            <li>
                                Process/submit the results at the bottom of that page.
                            </li>
                            <li>
                                Place all old rotated batteries onto the “rotate” pallet – these batteries will be listed as “EBT” stock in your inventory. FMP will collect these from time to time.                        
                            </li>
                            <li>
                                Any questions?: Please call Tim Denardo at: 920-224-2445
                            </li>                                                                                                                
                        </ol>
                    </td>                                        
                </tr>                                    
            </tbody>  
            <tfoot >
                <tr>
                    <td className={'logo'} >
                        <img src={fmpaddress} alt='FMP Address' width={300}/>
                    </td> 
                    <td className={'logo'} style={ {textAlign:'end'}}> 
                        <img src={fmpslogan} alt='FMP Address' width={300}/>
                    </td>                    
                </tr>
            </tfoot>         
        </table>

        </div>
    );
})


const mapStateToProps = (state) => {
   return {
    // invoicesState: state.invoicesReducer['items_fetchInvoices'],
    // invoicesPrintState: state.invoicesReducer['items_fetchInvoicesPrint'],
    //  authreducerState: state.authreducer
   }
  
};
  
const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SopRotatesPrintPage);